import lock_icon from "../../../../assets/images/padlock.png";
import AppButton from "../../../../components/AppButton/AppButton";
import { RouteNames } from "../../../../routes/routes";
import "./BloqueioConcluido.css";

/**
 * ? Esta tela trata a opção do usuário pela segunda via do cartão, apresentando
 * ? a mensagem adequada ao de acordo com o que ele escolheu.
 * **/
const BloqueioConcluido = (props: any) => {
  // Recuperando da rota a opção de usuário por segunda via
  let querSegundaViaParam = props.match.params.solicitarSegundaVia;

  const clickVoltar = () => {};

  function querSegundaVia() {
    if (querSegundaViaParam === "true") {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className="bloqueio-concluido-auth-content">
      <h1 id="bloqueio-concluido-auth-title">Bloqueio do Cartão</h1>

      <h3 id="bloqueio-concluido-auth-description">
        Tudo pronto!
        {querSegundaVia() ? (
          <h3>
            Agora é só você procurar um <span>posto de atendimento </span>
            TeuCard para retirada da 2ª via do teu cartão.
          </h3>
        ) : (
          <h3>
            O teu cartão agora está <strong>bloqueado</strong>.
          </h3>
        )}
      </h3>

      {/* Quando o usuário ler a mensagem da tela de conclusão de acordo com a escolha dele,
            poderá clicar aqui para finalizar o processo e retornar a tela anterior*/}
      <div className="bloqueio-concluido--btn-ok">
        <AppButton
          content="Beleza!"
          route={RouteNames.HOME}
          outlined={false}
          width="330px"
          click={clickVoltar}
        />
      </div>

      <img id="bloqueio-concluido-auth-padlock" src={lock_icon} alt="" />
    </div>
  );
};

export default BloqueioConcluido;
